module.exports = __webpack_public_path__ + "img/slot-hacksaw.5ce18dfc.png";